export default function checkChartNull(arr){
    return arr?.every(obj=>obj.y===undefined);
  }